import React from 'react';
import { useFormContext } from 'react-hook-form';

const Step8Review: React.FC = () => {
  const { getValues } = useFormContext();
  const formData = getValues();

  const formatValue = (value: any) => {
    if (value === undefined || value === null || value === '') return 'Not provided';
    return value;
  };

  return (
    <div className="solar-form-section">
      <div className="solar-form-review-section">
        <h3 className="solar-form-review-title">Personal Information</h3>
        <div className="solar-form-review-grid">
          <div className="solar-form-review-item">
            <span className="solar-form-review-label">Name:</span>
            <span className="solar-form-review-value">
              {formatValue(formData.firstName)} {formatValue(formData.lastName)}
            </span>
          </div>
          <div className="solar-form-review-item">
            <span className="solar-form-review-label">Email:</span>
            <span className="solar-form-review-value">{formatValue(formData.email)}</span>
          </div>
          <div className="solar-form-review-item">
            <span className="solar-form-review-label">Phone:</span>
            <span className="solar-form-review-value">{formatValue(formData.phone)}</span>
          </div>
        </div>
      </div>

      <div className="solar-form-review-section">
        <h3 className="solar-form-review-title">Property Information</h3>
        <div className="solar-form-review-grid">
          <div className="solar-form-review-item">
            <span className="solar-form-review-label">Address:</span>
            <span className="solar-form-review-value">{formatValue(formData.address)}</span>
          </div>
          <div className="solar-form-review-item">
            <span className="solar-form-review-label">City:</span>
            <span className="solar-form-review-value">{formatValue(formData.city)}</span>
          </div>
          <div className="solar-form-review-item">
            <span className="solar-form-review-label">State:</span>
            <span className="solar-form-review-value">{formatValue(formData.state)}</span>
          </div>
          <div className="solar-form-review-item">
            <span className="solar-form-review-label">ZIP Code:</span>
            <span className="solar-form-review-value">{formatValue(formData.zipCode)}</span>
          </div>
          <div className="solar-form-review-item">
            <span className="solar-form-review-label">Property Type:</span>
            <span className="solar-form-review-value">{formatValue(formData.propertyType)}</span>
          </div>
          <div className="solar-form-review-item">
            <span className="solar-form-review-label">Ownership:</span>
            <span className="solar-form-review-value">{formatValue(formData.propertyOwnership)}</span>
          </div>
        </div>
      </div>

      <div className="solar-form-review-section">
        <h3 className="solar-form-review-title">Roof Information</h3>
        <div className="solar-form-review-grid">
          <div className="solar-form-review-item">
            <span className="solar-form-review-label">Roof Type:</span>
            <span className="solar-form-review-value">{formatValue(formData.roofType)}</span>
          </div>
          <div className="solar-form-review-item">
            <span className="solar-form-review-label">Roof Age:</span>
            <span className="solar-form-review-value">{formatValue(formData.roofAge)}</span>
          </div>
        </div>
      </div>

      <div className="solar-form-review-section">
        <h3 className="solar-form-review-title">Energy Information</h3>
        <div className="solar-form-review-grid">
          <div className="solar-form-review-item">
            <span className="solar-form-review-label">Average Monthly Bill:</span>
            <span className="solar-form-review-value">{formatValue(formData.averageMonthlyBill)}</span>
          </div>
          <div className="solar-form-review-item">
            <span className="solar-form-review-label">Additional Information:</span>
            <span className="solar-form-review-value">{formatValue(formData.additionalInfo)}</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Step8Review; 